import { useSuggestionComments } from "../../../state/suggestionComments";
import { ReviewConversation, type ReviewTimelineEntry } from "../ReviewConversation";
export function SuggestionConversation({
  organizationId,
  recommendationId,
  composerHost = null,
  composerLayout,
  history,
}: {
  readonly organizationId: string;
  readonly recommendationId: string;
  readonly composerHost?: HTMLElement | null;
  readonly composerLayout?: "default" | "tabs";
  /** The suggestion's events, merged into this one timeline under an "Activity" heading. */
  readonly history?: ReadonlyArray<ReviewTimelineEntry>;
}) {
  const conversation = useSuggestionComments(organizationId, recommendationId);
  const body = (
    <ReviewConversation
      {...(composerLayout === undefined ? {} : { composerLayout })}
      key={`${organizationId}:${recommendationId}`}
      composerHost={composerHost}
      entityId={recommendationId}
      label="Suggestion comments"
      conversation={conversation}
      {...(history === undefined ? {} : { activity: history })}
    />
  );
  if (history === undefined) return body;
  return (
    <section className="space-y-5 border-t border-border/60 pt-6">
      <h2 className="text-sm font-semibold">Activity</h2>
      {body}
    </section>
  );
}
